import { Keyword } from './Keyword';

interface KeywordsProps {
  list: number[];
}

export const Keywords: React.FC<KeywordsProps> = ({ list }) => {
  const uniqueKeywords = Array.from(new Set(list)).sort((a, b) => a - b);

  return uniqueKeywords.length > 0 ? (
    <div>
      {uniqueKeywords?.map((keywordId) => (
        <Keyword key={`keyword-${keywordId}`} keywordId={keywordId} />
      ))}
    </div>
  ) : null;
};
